"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var mainHeaderFullWidthStyles = styles_1.makeStyles(function (theme) {
    var _a, _b;
    return ({
        stickyHeader: {
            position: 'sticky',
            top: 0,
            zIndex: 4,
            padding: 0,
        },
        step: (_a = {
                padding: theme.spacing(2) + " 0 " + theme.spacing(2) + " 0",
                display: 'flex',
                justifyContent: 'center'
            },
            _a[theme.breakpoints.down('sm')] = {
                padding: theme.spacing(1) + " 0 " + theme.spacing(1) + " 0",
            },
            _a),
        default: (_b = {
                color: theme.palette.common.black,
                backgroundColor: theme.palette.primary.contrastText,
                borderTop: "1px solid " + theme.palette.primaryDisabled.main,
                borderBottom: "1px solid " + theme.palette.primaryDisabled.main,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative'
            },
            _b[theme.breakpoints.down(theme.breakpoints.values.lg)] = {
                flexDirection: 'column',
            },
            _b[theme.breakpoints.down(theme.breakpoints.values.sm)] = {
                marginTop: 0,
            },
            _b[theme.breakpoints.down(theme.breakpoints.values.md)] = {
                borderTop: 'none',
            },
            _b),
        simple: {
            color: theme.palette.common.black,
            backgroundColor: theme.palette.primary.contrastText,
            borderTop: "1px solid " + theme.palette.primaryDisabled.main,
            borderBottom: "1px solid " + theme.palette.primaryDisabled.main,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
        },
        headerTitle: {
            display: 'inline',
            textAlign: 'center',
        },
    });
}, { name: 'Checkout_MainHeader_With_Back_Link' });
exports.default = mainHeaderFullWidthStyles;
